import { http } from '@pendo/http';

export function startOAuth (params) {
    return http.post('/api/s/_SID_/oauth', params);
}

export function getAllOAuthTokens () {
    return http.get('/api/s/_SID_/oauth');
}

export function getOAuthTokenById (id) {
    return http.get(`/api/s/_SID_/oauth/${id}`);
}

export function deleteOAuthTokenById (id) {
    return http.delete(`/api/s/_SID_/oauth/${id}`);
}

export function reauthOAuthToken (id, redirectPath, queryParameters) {
    return http.post(`/api/s/_SID_/oauth/${id}/reauth`, { redirectPath, queryParameters });
}

export function addEntityToToken (id, entityType, entityId) {
    return http.put(`/api/s/_SID_/oauth/${id}/${entityType}`, { entityId });
}

export function mapOAuthTokenByOwnerId (tokens) {
    const map = {};
    tokens.forEach((token) => {
        const ownerIds = token.items.reduce((acc, item) => {
            acc.push(item.id);

            return acc;
        }, []);
        ownerIds.forEach((id) => {
            map[id] = token;
        });
    });

    return map;
}
